// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Az-o","requiredAsterisk":"Info_requiredAsterisk__1gj0T"};